const focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    '[tabindex]',
    '[contentEditable=true]',
]
    .map((selector) => `${selector}:not([tabindex="-1"])`)
    .join(',');

export const ESCAPE_KEY = 27;
export const TAB_KEY = 9;

export function getFocusableElements(container: HTMLElement | null) {
    if (container == null) {
        return [];
    }
    return Array.from(container.querySelectorAll<HTMLElement>(focusableSelector));
}

export function containerSortedFocusableElements(container: HTMLElement | null) {
    const focusableElements = getFocusableElements(container);

    return focusableElements.slice().sort((aItem, zItem) => {
        const position = aItem.compareDocumentPosition(zItem);

        if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return -1;
        }
        if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return 1;
        }

        return 0;
    });
}

// The library keeps its panel stack private, so an open VxModal, VxSwal or command palette is found in the DOM.
export function hasOpenModal(): boolean {
    return null !== document.querySelector('.vx-modal-content, #command-palette-listbox');
}

export function keepAnchorDefaultBehavior(event: MouseEvent | KeyboardEvent): boolean {
    return Boolean(
        event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey ||
            ((<MouseEvent>event).button && (<MouseEvent>event).button !== 0)
    );
}
